var exports = {
  "tb": "UserProfileModal.module__noteTextarea___VnRsc2",
  "CR": "UserProfileModal.module__modalRoot___VnRsc2",
  "eF": "UserProfileModal.module__userInfo___VnRsc2",
  "hR": "UserProfileModal.module__userInfoHeader___VnRsc2",
  "hA": "UserProfileModal.module__userInfoHeaderDesktop___VnRsc2",
  "Rn": "UserProfileModal.module__userInfoContent___VnRsc2",
  "yn": "UserProfileModal.module__profileDataWarning___VnRsc2",
  "S7": "UserProfileModal.module__nameRow___VnRsc2",
  "nT": "UserProfileModal.module__userName___VnRsc2",
  "a1": "UserProfileModal.module__userTag___VnRsc2",
  "Fj": "UserProfileModal.module__usernameRow___VnRsc2",
  "hI": "UserProfileModal.module__pronouns___VnRsc2",
  "sM": "UserProfileModal.module__srOnly___VnRsc2",
  "Li": "UserProfileModal.module__customStatusText___VnRsc2",
  "Ef": "UserProfileModal.module__customStatusRow___VnRsc2",
  "_z": "UserProfileModal.module__tagBadgeRow___VnRsc2",
  "U3": "UserProfileModal.module__badgesWrapper___VnRsc2",
  "ZV": "UserProfileModal.module__userNoteEditor___VnRsc2",
  "xu": "UserProfileModal.module__noteLabel___VnRsc2",
  "_j": "UserProfileModal.module__noteTextareaBase___VnRsc2",
  "jd": "UserProfileModal.module__noteTextareaEditing___VnRsc2",
  "EN": "UserProfileModal.module__noteTextareaNotEditing___VnRsc2",
  "bs": "UserProfileModal.module__profileContent___VnRsc2",
  "EM": "UserProfileModal.module__profileContentHeader___VnRsc2",
  "cI": "UserProfileModal.module__bannerContainer___VnRsc2",
  "HG": "UserProfileModal.module__bannerMask___VnRsc2",
  "_e": "UserProfileModal.module__bannerImage___VnRsc2",
  "N1": "UserProfileModal.module__headerContainer___VnRsc2",
  "H": "UserProfileModal.module__avatarContainer___VnRsc2",
  "fc": "UserProfileModal.module__actionButtonsContainer___VnRsc2",
  "hQ": "UserProfileModal.module__contentContainer___VnRsc2",
  "sq": "UserProfileModal.module__profileContentWrapper___VnRsc2",
  "zL": "UserProfileModal.module__scrollerFullHeight___VnRsc2",
  "jT": "UserProfileModal.module__modalContainer___VnRsc2",
  "uu": "UserProfileModal.module__actionButtons___VnRsc2",
  "iA": "UserProfileModal.module__buttonIcon___VnRsc2",
  "ro": "UserProfileModal.module__menuIcon___VnRsc2",
  "WB": "UserProfileModal.module__avatarFocusRing___VnRsc2",
  "VS": "UserProfileModal.module__tabsWrapper___VnRsc2",
  "OT": "UserProfileModal.module__mutualFriendsList___VnRsc2",
  "Z8": "UserProfileModal.module__mutualSectionDivider___VnRsc2",
  "KF": "UserProfileModal.module__mutualFriendItem___VnRsc2",
  "vu": "UserProfileModal.module__active___VnRsc2",
  "Qd": "UserProfileModal.module__mutualItemIconFrame___VnRsc2",
  "D9": "UserProfileModal.module__mutualFriendInfo___VnRsc2",
  "eV": "UserProfileModal.module__mutualFriendName___VnRsc2",
  "zD": "UserProfileModal.module__mutualFriendUsername___VnRsc2",
  "p$": "UserProfileModal.module__emptyState___VnRsc2",
  "Ny": "UserProfileModal.module__mutualGuildIcon___VnRsc2",
  "me": "UserProfileModal.module__separator___VnRsc2",
  "AI": "UserProfileModal.module__emptyStateIcon___VnRsc2",
};

module.exports = exports;
